import { render } from "./TalkNowRecord.vue?vue&type=template&id=40ee90b6&scoped=true"
import script from "./TalkNowRecord.vue?vue&type=script&lang=js"
export * from "./TalkNowRecord.vue?vue&type=script&lang=js"

import "./TalkNowRecord.vue?vue&type=style&index=0&id=40ee90b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ee90b6"]])

export default __exports__